import { alpha, createTheme, getContrastRatio } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Palette {
    ochre: Palette['primary'];
    violet: Palette['primary'];
    coolBlue: Palette['primary'];
    coolTeal: Palette['primary'];
    darkTeal: Palette['primary'];
  }

  interface PaletteOptions {
    ochre?: PaletteOptions['primary'];
    violet?: PaletteOptions['primary'];
    coolBlue?: PaletteOptions['primary'];
    coolTeal?: PaletteOptions['primary'];
    darkTeal?: PaletteOptions['primary'];
  }
}

// Extend Button component with custom colors and variants
declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    ochre: true;
    violet: true;
    coolBlue: true;
    coolTeal: true;
    darkTeal: true;
  }

  interface ButtonPropsVariantOverrides {
    coolBlueButton: true;
    colorLessButton: true;
    challengeButton: true;
  }
}

const violetBase = '#7F00FF';
const violetMain = alpha(violetBase, 0.7);

export const layoutTheme = createTheme({
  cssVariables: {
    colorSchemeSelector: 'data-toolpad-color-scheme',
  },
  colorSchemes: {
    light: {
      palette: {
        background: {
          default: '#EAFDF8',
          paper: '#EAFDF8',
        },
        text: {
          primary: '#000000',
        },
      },
    },
    dark: {
      palette: {
        background: {
          default: '#44546A',
          paper: '#44546A',
        },
        text: {
          primary: '#FFFF',
        },
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 600,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    ochre: {
      main: '#E3D026',
      light: '#E9DB5D',
      dark: '#A29415',
      contrastText: '#242105',
    },
    violet: {
      main: violetMain,
      light: alpha(violetBase, 0.5),
      dark: alpha(violetBase, 0.9),
      contrastText: getContrastRatio(violetMain, '#fff') > 4.5 ? '#fff' : '#111',
    },
    coolBlue: {
        main: 'rgba(68, 84, 106, 1)',
        light: 'rgba(68, 84, 106, 1)',
        dark: 'rgba(68, 84, 106, 1)',
        contrastText: 'rgba(255, 255, 255, 1)z',
    },
    coolTeal: {
      main: 'rgba(55, 179, 162, 1)',
      light: 'rgba(55, 179, 162, 1)',
      dark: 'rgba(55, 179, 162, 1)',
      contrastText: 'rgba(55, 179, 162, 1)'
    },
    darkTeal: {
        main: '#098574',
        contrastText: '#fff',
    },
  },
  components: {
    MuiButton: {
      variants: [
        { props: { variant: 'coolBlueButton'},
          style: {
            backgroundColor: 'rgba(68, 84, 106, 1)',
            fontSize: '20px',
            textTransform: 'none',
            color: 'white'
          }},
        { props: { variant: 'colorLessButton'},
          style: {
            backgroundColor: 'transparent',
            fontSize: '13px',
            color: '#000',
            textTransform: 'none',
            textDecoration: 'underline #D2DDE8',
            textUnderlineOffset: '10px',
            paddingLeft: '0'
          }},
        { props: { variant: 'challengeButton'},
          style: {
            backgroundColor: '#44546A',
            fontSize: '20px',
            color: '#FAF9F6',
            textTransform: 'none',
            textDecoration: 'none',
            textUnderlineOffset: '10px'
          }}
      ]
    }
  }
});